import React, { useEffect, useState } from 'react';
import './App.css';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { SeApp } from '@se/web-ui-react';
// import Dashboard from './containers/dashboard';
import Products from './containers/products';
import Devices from './containers/devices';
import UserManagement from './containers/userManagement';
import Team from './containers/teams';
import CertificationManagement from './containers/certificationManagement.js';
import NavBar from './components/navBar/navbar';
import Header from './components/header/header';
import Constants from './constants.js';
import ProductInformation from './containers/productInformation';
import Unauthorized from './containers/unAuthorized';
import LoginCallback from './containers/loginCallback';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import authConfig from './authConfig';
import LogingLoader from './loading.js';
import { useDispatch } from 'react-redux';
import { redirectToLogin } from './authActions.js';
import LogoutScreen from './containers/logout';
import AccessDenied from './containers/accessDenied.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LogoutModal from './modals/logoutModal.js';
import { setShowLogoutModalCallback } from './axiosInterceptors.js';
import { NullUndefinedCheck } from './genericFunctions/nullUndefinedCheck.js';

function App() {
  const [isSessionActive, setSessionFlag] = useState(false)
  const { HEADER_TITLE } = { ...Constants };
  const userManager = new UserManager({
    ...authConfig,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  });
  const [routeAccessDataFetched, setRouteAccessDataFlag] = useState(false)

  const ProtectedRoute = ({allowedAccessLevel, element}) => {
    const userDetails = sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails')) : null;
    const session = sessionStorage.getItem('session') ? sessionStorage.getItem('session') : null
    const userAccessLevel = userDetails?.roleId ? Number(userDetails?.roleId) : null;
    if(session == 'inactive') return (<LogoutScreen/>)
    if(session == 'active' && allowedAccessLevel.includes(userAccessLevel)) return (element)
    if(session == 'active' && !allowedAccessLevel.includes(userAccessLevel)) return (<Navigate to='/accessDenied' />)
    if(session == null) return (<Navigate to='/login' />)
  };

  // **************************Logic to redirect the User post Login********************/
  const LoginRedirect = () => {
    const session = sessionStorage.getItem('session') ? sessionStorage.getItem('session') : null
    const dispatch = useDispatch();
    sessionStorage.removeItem('session')
    useEffect(() => {
      if(session == null) dispatch(redirectToLogin())
    }, [dispatch]);

    return <LogingLoader/>
  } 

  useEffect(() => {
    setShowLogoutModalCallback(setSessionFlag)
  }, [isSessionActive])

  useEffect(() => {
    const interval = setInterval(() => {
      const routeAccessData = !NullUndefinedCheck(sessionStorage.getItem('routeAccessData')) ? JSON.parse(sessionStorage.getItem('routeAccessData')) : null
      if(!NullUndefinedCheck(routeAccessData)) {
        setRouteAccessDataFlag(true);
        clearInterval(interval)
      }
    }, 100)
    return () => clearInterval(interval)
  }, [])

  // const checkData = () => {
  //   console.log(!NullUndefinedCheck(null), sessionStorage.getItem('session'))
  //   return false
  // }

  //****************************Logging The User has Loaded or not **************************/
  // userManager.events.addUserLoaded((user) => {
  //   console.log('User Loaded and Stored:', user)
  // })     
  // useEffect(() => {
  //   console.log('User state:', user)
  // }, [user]);

  // if(checkData()) return <p>Fetching Data.....</p>

  return (
    <SeApp style={{ backgroundColor: '#ececec' }}>
      <BrowserRouter>
        <div>
          { routeAccessDataFetched && <Header title={HEADER_TITLE}/>}
          { routeAccessDataFetched && <NavBar />}
          <div className='mainContainer'>
            <Routes>
              <Route path='/' element={<Navigate to='/login'/> } />
              {/* <Route path='/dashboard' element={<ProtectedRoute allowedAccessLevel={[1, 2, 3]} element={<Dashboard/>}/>} /> */}
              <Route path='/products' element={<ProtectedRoute allowedAccessLevel={[1, 2, 3]} element={<Products/>}/>} />
              <Route path='/devices' element={<ProtectedRoute allowedAccessLevel={[1, 2, 3]} element={<Devices/>}/>} />
              <Route path='/usermanagement' element={<ProtectedRoute allowedAccessLevel={[1]} element={<UserManagement/>}/>} />
              <Route path='/teams' element={<ProtectedRoute allowedAccessLevel={[2, 3]} element={<Team/>}/>}/>
              <Route path='/certifications' element={<ProtectedRoute allowedAccessLevel={[1, 2, 3]} element={<CertificationManagement/>}/>} />
              <Route path='/productInformation/:id' element={<ProtectedRoute allowedAccessLevel={[1, 2, 3]} element={<ProductInformation/>}/>} />
              <Route exact path='/logout' element={<ProtectedRoute allowedAccessLevel={[1, 2, 3]} element={<LogoutScreen/>}/>} />
              <Route exact path='/login' element={<LoginRedirect/>}/>
              <Route exact path='/loginCallback' element={<LoginCallback userManager={userManager} />} />
              <Route exact path='/unauthorized' element={<Unauthorized />} />
              <Route exact path='/accessDenied' element={<AccessDenied />} />
            </Routes>
            {isSessionActive && <LogoutModal onClose={() => setSessionFlag(false)} isVisible={isSessionActive}/>}
          </div>
          <ToastContainer/>
        </div>
      </BrowserRouter>
    </SeApp>
  );
}

export default App;
